<template>
  <div class="question-content">
    <div class="question-icon">
      <svg 
        class="tw-w-16 tw-h-16 tw-text-blue-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <p class="question-text">
      {{ currentStep.data.question }}
    </p>
    <div class="button-group">
      <button
        class="btn-yes"
        @click="$emit('yes')"
      >
        <svg 
          class="tw-w-5 tw-h-5 tw-mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M5 13l4 4L19 7"
          />
        </svg>
        Yes
      </button>
      <button
        class="btn-no"
        @click="$emit('no')"
      >
        <svg 
          class="tw-w-5 tw-h-5 tw-mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        No
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YesNoQuestion',
  props: {
    currentStep: {
      type: Object,
      required: true
    }
  },
  emits: ['yes', 'no']
};
</script>

<style scoped>
.question-content {
  @apply tw-px-8 tw-pb-8;
  animation: fadeIn 0.3s ease-out;
}

.question-icon {
  @apply tw-flex tw-justify-center tw-mb-6;
}

.question-text {
  @apply tw-text-lg tw-text-gray-600 tw-text-center tw-mb-8;
  @apply tw-leading-relaxed;
}

.button-group {
  @apply tw-flex tw-gap-4 tw-justify-center;
}

.btn-yes,
.btn-no {
  @apply tw-inline-flex tw-items-center tw-justify-center;
  @apply tw-font-medium tw-transition-all tw-duration-200;
  @apply tw-rounded-lg tw-shadow-sm;
}

.btn-yes {
  @apply tw-px-8 tw-py-3 tw-bg-green-500 tw-text-white;
  @apply tw-transform;
}

.btn-yes:hover {
  @apply tw-bg-green-600 tw-shadow-lg;
  transform: scale(1.05);
}

.btn-no {
  @apply tw-px-8 tw-py-3 tw-bg-red-500 tw-text-white;
  @apply tw-transform;
}

.btn-no:hover {
  @apply tw-bg-red-600 tw-shadow-lg;
  transform: scale(1.05);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .question-content {
    @apply tw-px-6;
  }
  
  .question-text {
    @apply tw-text-base;
  }
  
  .button-group {
    @apply tw-flex-col tw-w-full;
  }
  
  .btn-yes,
  .btn-no {
    @apply tw-w-full;
  }
}

@media print {
  .btn-yes,
  .btn-no {
    display: none !important;
  }
}
</style>
